import axios from "axios";
import Cookies from "js-cookie";
const SERVER_URL = "https://fes-sociologia.com/api";

const api = axios.create(
  {
  baseURL: SERVER_URL,
  withCredentials: true,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
});

// Enhanced interceptor with additional safeguards
api.interceptors.response.use(
  response => response,
  async (error) => {
    // Handle network errors (no response received)
    if (!error.response) {
      console.error('Network error:', error);
      return Promise.reject(error);
    }

    const originalRequest = error.config;
    
    // Special handling for 401 Unauthorized
    if (error.response.status === 401) {
      // Skip handling for refresh requests to prevent infinite loops
      if (originalRequest.url.includes('/refresh') || originalRequest._retry) {
        console.warn('Auth loop detected, forcing logout');
        await performFullLogout();
        return Promise.reject(error);
      }
      
      // Mark request as already retried
      originalRequest._retry = true;
      
      try {
        console.log('Attempting token refresh...');
        
        // Attempt refresh with timeout
        await api.get('/refresh', { 
          skipAuthHandling: true,
          timeout: 5000 // 5 second timeout
        });
        
        console.log('Token refresh successful, retrying original request');
        return api(originalRequest);
      } catch (refreshError) {
        console.error('Token refresh failed:', refreshError);
        
        // Differentiate between refresh failures
        if (refreshError.response) {
          // Server responded with error
          if (refreshError.response.status === 401) {
            console.log('Refresh token expired, logging out');
          }
        }
        
        await performFullLogout();
        return Promise.reject(refreshError);
      }
    }
    
    // For all other error statuses
    console.error('API error:', {
      status: error.response.status,
      url: originalRequest.url,
      data: error.response.data
    });
    return Promise.reject(error);
  }
);


const loginFES = async (formData, email) => {
  try {
    const response = await api.post('/login', formData);

    if (response.status === 200) {
      // Set admin cookie if needed
      if (["direccion@fes-sociologia.com", "test@test.com"].includes(email)) {
        Cookies.set("isAdmin", "1", { 
          secure: true, 
          sameSite: 'Strict' 
        });
      }

      // Verify login by calling auth-protected endpoint
      try {
        await api.get('/verify_auth');
        localStorage.setItem('isLogged', '1')
        window.location.href = '/perfil';
      } catch (verifyError) {
        throw new Error('Authentication verification failed');
      }
    }
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

// Centralized logout function
async function performFullLogout() {
  try {
    // Call server-side logout to clear HttpOnly cookies
    await api.post('/logout');
  } catch (error) {
    console.error('Logout API call failed, proceeding with client-side cleanup', error);
  }
  
  // Client-side cleanup
  Cookies.remove('isAdmin');
  localStorage.removeItem('isLogged');
  localStorage.removeItem('me');
  if (!window.location.pathname.includes('/login')) {
    window.location.href = '/login';
  }
}

// Remove checkLoggedFES - not needed with middleware protection
const logoutFES = async () => {
  await performFullLogout();
};

export { loginFES, logoutFES, api };
